import { render } from "./verification_form.html?vue&type=template&id=43a4c5a0&external"
import script from "./verification_form.js?vue&type=script&lang=js&external"
export * from "./verification_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__